import { CalcIcon } from "./CalcIcon";
import { moedaOrcamento, OrcamentoBotao } from "./OrcamentoUI";

export function TelaSucesso({ orcamento, onEnviar, onVerOrcamento, onIrOrcamentos }) {
  const total = (orcamento?.itens || []).reduce((s, it) => s + (parseFloat(it.preco) || 0) * (it.quantidade || 1), 0);
  return <section className="budget-panel budget-success">
    <span className="budget-success-mark"><CalcIcon name="check" size={32} /></span>
    <h1>Orçamento criado com sucesso!</h1><p className="budget-note">{orcamento?.nomeCliente}</p>
    <div className="budget-price"><span>Total do orçamento</span><strong>{moedaOrcamento(total)}</strong></div>
    <div className="budget-financial-actions"><OrcamentoBotao onClick={onEnviar}><CalcIcon name="upload" />Enviar para cliente</OrcamentoBotao><OrcamentoBotao outline onClick={onVerOrcamento}>Ver orçamento</OrcamentoBotao><OrcamentoBotao outline onClick={onIrOrcamentos}>Meus orçamentos</OrcamentoBotao></div>
  </section>;
}
